"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listChannel = listChannel;
exports.createChannel = createChannel;
exports.allChannel = allChannel;
exports.readChannel = readChannel;
exports.updateChannel = updateChannel;
exports.deleteChannel = deleteChannel;

var _request = _interopRequireDefault(require("@/utils/request"));

function listChannel(query) {
  return (0, _request.default)({
    url: '/channel/list',
    method: 'get',
    params: query
  });
}

function createChannel(data) {
  return (0, _request.default)({
    url: '/channel/create',
    method: 'post',
    data: data
  });
}

function allChannel(data) {
  return (0, _request.default)({
    url: '/channel/all',
    method: 'get'
  });
}

function readChannel(query) {
  return (0, _request.default)({
    url: '/channel/read',
    method: 'get',
    params: query
  });
}

function updateChannel(data) {
  return (0, _request.default)({
    url: '/channel/update',
    method: 'post',
    data: data
  });
}

function deleteChannel(data) {
  return (0, _request.default)({
    url: '/channel/delete',
    method: 'post',
    data: data
  });
}